import Vue from 'vue';
import App from './App.vue';

import VueRouter from 'vue-router';
// import 'carbon-components/css/carbon-components.css';
import CarbonComponentsVue from '@carbon/vue';

import Lavori from '@/components/lavori/Lavori';
import Fatture from '@/components/contabilità/Fatture';
import Bilancio from "@/components/contabilità/Bilancio";
import Clienti from "@/components/ditte/Clienti";
import Fornitori from "@/components/ditte/Fornitori";
import Terzisti from "@/components/ditte/Terzisti";
import Fondi from "@/components/posizioni/Fondi";
import Colture from "@/components/lavori/Colture";
import Operai from "@/components/lavori/Operai";
import LavoriTipo from "@/components/lavori/LavoriTipo";
import Materiali from "@/components/movimenti/Materiali";
import Macchine from "@/components/movimenti/Macchine";
import UtilizzoMateriali from "@/components/movimenti/UtilizzoMateriali";
import Acquisti from "@/components/movimenti/Acquisti";
import RicercaLavori from "@/components/lavori/RicercaLavori";
import RicercaOperai from "@/components/lavori/RicercaOperai";
import RicercaBilancio from "@/components/contabilità/RicercaBilancio";
import RicercaFatture from "@/components/contabilità/RicercaFatture";
import RicercaAcquisti from "@/components/movimenti/RicercaAcquisti";
import RicercaUtilizzo from "@/components/movimenti/RicercaUtilizzo";
import RicercaMateriali from "@/components/movimenti/RicercaMateriali";
import GenerazioneFatturePerLavori from "@/components/contabilità/GenerazioneFatturePerLavori";
import RiepilogoFattPerCliente from "@/components/contabilità/RiepilogoFattPerCliente";
import RiepilogoLavoriPerCliente from "@/components/lavori/RiepilogoLavoriPerCliente";
import Comuni from "@/components/posizioni/Comuni";
import Province from "@/components/posizioni/Province";
import DataValida from "@/components/DataValida";

Vue.use(VueRouter);
Vue.use(CarbonComponentsVue);

Vue.config.productionTip = false

Vue.component('router-link', Vue.options.components.RouterLink)
Vue.component('router-view', Vue.options.components.RouterView)
Vue.component('data-valida', DataValida)

const router = new VueRouter({
  routes: [
    {
      path:'/lavori', name:'lavori', component: Lavori
    },
    {
      path:'/fatture', name:'fatture', component: Fatture
    },
    {
      path:'/bilancio', name:'bilancio', component: Bilancio
    },
    {
      path:'/clienti', name:'clienti', component: Clienti
    },
    {
      path:'/fornitori', name:'fornitori', component: Fornitori
    },
    {
      path:'/terzisti', name:'terzisti', component: Terzisti
    },
    {
      path:'/fondi', name:'fondi', component: Fondi
    },
    {
      path:'/colture', name:'colture', component: Colture
    },
    {
      path:'/operai', name:'operai', component: Operai
    },
    {
      path:'/lavori-tipo', name:'lavoritipo', component: LavoriTipo
    },
    {
      path:'/materiali', name:'materiali', component: Materiali
    },
    {
      path:'/macchine', name:'macchine', component: Macchine
    },
    {
      path:'/utilizzo-materiali', name:'utilizzomateriali', component: UtilizzoMateriali
    },
    {
      path:'/acquisti', name:'acquisti', component: Acquisti
    },
    {
      path:'/ricerca-lavori', name:'ricercalavori', component: RicercaLavori
    },
    {
      path:'/ricerca-operai', name:'ricercaoperai', component: RicercaOperai
    },
    {
      path:'/ricerca-bilancio', name:'ricercabilancio', component: RicercaBilancio
    },
    {
      path:'/ricerca-fatture', name:'ricercafatture', component: RicercaFatture
    },
    {
      path:'/ricerca-acquisti', name:'ricercaacquisti', component: RicercaAcquisti
    },
    {
      path:'/ricerca-utilizzo', name:'ricerca-utilizzo', component: RicercaUtilizzo
    },
    {
      path:'/ricerca-materiali', name:'ricerca-materiali', component: RicercaMateriali
    },
    {
      path:'/generazione-fatture', name:'generazione-fatture', component: GenerazioneFatturePerLavori
    },
    {
      path:'/riepilogo-fatture', name:'riepilogo-fatture', component: RiepilogoFattPerCliente
    },
    {
      path:'/riepilogo-lavori', name:'riepilogo-lavori', component: RiepilogoLavoriPerCliente
    },
    {
      path:'/comuni', name:'comuni', component: Comuni
    },
    {
      path:'/province', name:'province', component: Province
    },
    {
      path:'*', component: Lavori
    }
  ]
})

Vue.prototype.$statiPossibili = {"non_modificato":1, "modificato":2, "nuovo":3};

// eslint-disable-next-line no-unused-vars
export function validaDataIT(dateString) {
//  let dateformat = "/^(0?[1-9]|[1-2][0-9]|3[01])[\/](0?[1-9]|1[0-2])";
  return true;
}

new Vue({
  router: router,
  render: h => h(App),
}).$mount('#app')
